import { Text, View } from '@react-pdf/renderer'
import { FC } from 'react'
import { pdfStyles } from './pdfStyles'

export const TableRow2: FC<{ col1: string; col2?: string; col3: string; col4?: string }> = ({
  col1,
  col2,
  col3,
  col4,
}) => {
  return (
    <View style={pdfStyles.tableRow}>
      <View style={{ ...pdfStyles.tableColumn, ...pdfStyles.tableColumnTitle }}>
        <Text>{col1}</Text>
      </View>
      <View style={{ ...pdfStyles.tableColumn, width: '30%' }}>
        <Text>{col2}</Text>
      </View>
      <View style={{ ...pdfStyles.tableColumn, ...pdfStyles.tableColumnTitle }}>
        <Text>{col3}</Text>
      </View>
      <View style={{ ...pdfStyles.tableColumn, width: '30%' }}>
        <Text>{col4}</Text>
      </View>
    </View>
  )
}
